module.exports = __webpack_public_path__ + "static/img/14000781.0ffbd9aa.png";